import { Axios, ToJson, UrlFactory } from "@gsx/common";
import {
    QuiltyInsightsBody,
    QuiltyInsightsListItem,
    QuiltyInsightsListQuery,
    QuiltyInsightsListResponse,
} from "@gsx/common/src/types/http/admin/quiltyInsights";
import { adaptDate } from "../adapters";

const adaptRequest = (data: any): QuiltyInsightsListItem => ({
    ...data,
    submissionDate: adaptDate(data.submissionDate),
});

export class QuiltyInsights {
    private readonly urlFactory: UrlFactory;

    public constructor(private readonly axios: Axios, urlFactory: UrlFactory) {
        this.urlFactory = urlFactory.to("/admin/quiltyInsights");
    }

    public async list(params: QuiltyInsightsListQuery): Promise<QuiltyInsightsListResponse> {
        const url = this.urlFactory.create("/");
        const response = await this.axios.get(url, { params });
        return {
            ...response.data,
            data: response.data.data.map(adaptRequest),
        };
    }

    public async create(
        body: Partial<ToJson<QuiltyInsightsBody>>,
        formData: FormData,
    ): Promise<void> {
        const url = this.urlFactory.create(`/`);
        await this.axios
            .post(url, body)
            .then(async (res) => this.uploadMedia(res.data.id, formData));
    }

    public async update(
        id: string,
        body: Partial<ToJson<QuiltyInsightsBody>>,
        formData: FormData,
    ): Promise<void> {
        const url = this.urlFactory.create(`/${id}`);
        await this.axios.put(url, body).then(async () => this.uploadMedia(id, formData));
    }

    public async get(id: string): Promise<QuiltyInsightsBody> {
        const url = this.urlFactory.create(`/${id}`);
        const response = await this.axios.get(url);
        return response.data as QuiltyInsightsBody;
    }

    public async delete(id: string): Promise<void> {
        const url = this.urlFactory.create(`/${id}`);
        await this.axios.delete(url);
    }

    private async uploadMedia(id: string, formData: FormData) {
        if (formData.has("picture") && formData.get("picture") !== "null") {
            const quiltyInsightsMediaUrl = this.urlFactory.create(`/${id}/media`);

            await this.axios.put(quiltyInsightsMediaUrl, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
        }
    }
}
